import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, Card, Col, FormCheck, Row } from 'react-bootstrap'
import { selectAppOnline, selectDownloadStatus, selectTranslations } from 'redux/selector'
import { TRANSLATIONS } from 'config/constants'
import { useGlobalModalContext } from 'features/Modal/GlobalModal'
import { DownloadStatus } from 'redux/reducers/downloadReducer'
import useOfflineDownloadManager from '../hooks/useOfflineDownloadManager'
import DCAImage from 'components/DCAImage'
import images from 'assets/images/images'

export const DOWNLOAD_OPTIONS = {
  ALL: 'all',
  HOME_AND_GARDEN: 'home_and_garden',
  PROFESSIONAL: 'professional',
}

const DownloadBlock = () => {
  const { showModal, hideModal } = useGlobalModalContext()
  const { startOfflineDownload } = useOfflineDownloadManager()

  const isAppOnline = useSelector(selectAppOnline)
  const translations = useSelector(selectTranslations)
  const downloadStatus = useSelector(selectDownloadStatus)

  const [selectedOptions, setSelectedOptions] = useState<string[]>([])

  const {
    all: allOptions = TRANSLATIONS.all,
    finished: finishedTitle = TRANSLATIONS.finished,
    download: downloadTitle = TRANSLATIONS.download,
    last_download: lastDownload = TRANSLATIONS.lastDownload,
    settings_download_caption: downloadCaption = TRANSLATIONS.settingsDownloadCaption,
    download_status: downloadStatusTxt = TRANSLATIONS.downloadStatus,
    nothing_is_selected_for_download:
      nothingSelectedMsg = TRANSLATIONS.nothingIsSelectedForDownload,
    web_offline_message_prompt: offlineMsg = TRANSLATIONS.youAreOffline,
  } = translations || {}

  useEffect(() => {
    if (downloadStatus === DownloadStatus.Finished) {
      hideModal()
    }
  }, [downloadStatus])

  const messageModal = () => {
    if (!isAppOnline) {
      return offlineMsg
    }
    if (selectedOptions.length === 0) {
      return nothingSelectedMsg
    }
    return ''
  }

  const onOptionChange = (option: string) => {
    if (option === DOWNLOAD_OPTIONS.ALL) {
      if (selectedOptions.includes(option)) {
        setSelectedOptions([])
      } else {
        setSelectedOptions([
          DOWNLOAD_OPTIONS.ALL,
          DOWNLOAD_OPTIONS.HOME_AND_GARDEN,
          DOWNLOAD_OPTIONS.PROFESSIONAL,
        ])
      }
      return
    }

    const selectedCurrent = selectedOptions.filter((item) => item !== DOWNLOAD_OPTIONS.ALL)

    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedCurrent.filter((item) => item !== option))
    } else if (selectedCurrent.length === 1) {
      setSelectedOptions([DOWNLOAD_OPTIONS.ALL, ...selectedCurrent, option])
    } else {
      setSelectedOptions([...selectedOptions, option])
    }
  }

  const onShowDownloadModal = () => {
    showModal('DOWNLOAD_MODAL', {
      showModal: true,
      handleHide: hideModal,
    })
  }

  const onDownload = async (): Promise<void> => {
    try {
      if (!isAppOnline || selectedOptions.length === 0) {
        showModal('CONFIRM_MODAL', {
          showModal: true,
          message: messageModal(),
          handleClose: hideModal,
        })
        return
      }

      if (downloadStatus === DownloadStatus.Initial) {
        onShowDownloadModal()
        startOfflineDownload(selectedOptions)
      }
    } catch (error) {
      console.error('onDownload error', error)
    }
  }

  const renderDownloadContent = () => {
    switch (downloadStatus) {
      /* case DownloadStatus.Initial:
        return (
          <Button id='onboarding-btn-download' className='app-button' onClick={onDownload}>
            {downloadTitle.toUpperCase()}
          </Button>
        ) */

      case DownloadStatus.Downloading:
        return (
          <Button id='onboarding-btn-download' className='app-button'>
            <DCAImage className='download-loader' src={images.loading} />
          </Button>
        )

      case DownloadStatus.Finished:
        return (
          <Button id='onboarding-btn-download' className='app-button' disabled>
            {finishedTitle.toUpperCase()}
          </Button>
        )

      default:
        break
    }
  }

  return (
    <Card className='download-block setting-card'  style={{ 
      pointerEvents: 'none', 
      filter: 'grayscale(100%)', 
      backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
      <h6 className='settings-heading'>
        <i className='karcher-icon settings-icons'>&#xe851;</i>
        {downloadTitle}
      </h6>

      <p className='settings-caption' style={{fontSize: 10}}>{downloadCaption}</p>

      <Row className='mt-2'>
        <Col md='3'>
          <FormCheck
            label={allOptions}
            checked={selectedOptions.includes(DOWNLOAD_OPTIONS.ALL)}
            onChange={() => onOptionChange(DOWNLOAD_OPTIONS.ALL)}
          />
        </Col>
        <Col md='5'>
          <FormCheck
            label='Home & Garden'
            checked={selectedOptions.includes(DOWNLOAD_OPTIONS.HOME_AND_GARDEN)}
            onChange={() => onOptionChange(DOWNLOAD_OPTIONS.HOME_AND_GARDEN)}
          />
        </Col>
        <Col md='4'>
          <FormCheck
            label='Professional'
            checked={selectedOptions.includes(DOWNLOAD_OPTIONS.PROFESSIONAL)}
            onChange={() => onOptionChange(DOWNLOAD_OPTIONS.PROFESSIONAL)}
          />
        </Col>
      </Row>

      {/* <Row>
        <p className='last-download'>{lastDownload}</p>
      </Row> */}

      <Row className='mt-2'>
        <Col md='7'>
          {/* <Button className='app-button' onClick={onShowDownloadModal}>
            {downloadStatusTxt.toUpperCase()}
          </Button> */}
        </Col>
        <Col md='5'>{renderDownloadContent()}</Col>
      </Row>
    </Card>
  )
}

export default DownloadBlock
